//接口开关
// var pro = "http://pro.win-credit.com"; //线上
var pro = "" //本地代理
    // var pro = "http://47.94.201.188:8089"
export default {
    pro,
}


// WEBPACK FOOTER //
// ./src/api/global.js